module.exports = __webpack_public_path__ + "img/06_Excellence_Award.e772902d.png";